/* ==========================================================================
   st-stripe.js — Shirtology · Premium Stripe Shirt landing page.

   Loaded only by sections/st-stripe-landing.liquid. No dependencies, no build
   step, no framework: this page is opened on mid-range Android inside the
   Facebook and Instagram in-app browsers, where every parsed kilobyte is time
   the visitor spends looking at nothing.

   Everything degrades without JS. The page is fully readable and every link
   works; this file only adds the language toggle, the scroll reveal and the
   thumb-reach dock.
   ========================================================================== */

(function () {
  'use strict';

  var root = document.getElementById('st-root');
  if (!root) return;

  document.documentElement.classList.remove('no-js');

  /* ------------------------------------------------------------------------
     Per-drop config.

     This file is the engine for EVERY Shirtology drop-landing page, not just
     the stripe one it was written for (see snippets/sl-landing.liquid). The
     handful of things that differ per campaign are read from #st-root rather
     than written in here, and every default below is the stripe page's own
     value, so that page behaves exactly as it did before this existed.

     `cartKey` is the one that must never be shared. Every landing page is on
     the same origin, so two drops on one key would show each other's lines —
     a buyer who half-filled a bag on one page would open the next and find
     shirts they never picked.
     ---------------------------------------------------------------------- */
  function cfgAttr(name, fallback) {
    var v = root.getAttribute(name);
    return v === null || v === '' ? fallback : v;
  }

  var CFG = {
    cartKey: cfgAttr('data-cart-key', 'st-cart'),
    source: cfgAttr('data-source', 'Stripe landing'),
    contentName: cfgAttr('data-content-name', 'Premium Stripe Shirt'),
    contentCategory: cfgAttr('data-content-category', 'Stripe Shirt'),
    bnStrict: cfgAttr('data-bn-strict', 'false') === 'true',
    revealSizes: cfgAttr('data-reveal-sizes', 'false') === 'true'
  };

  /* ------------------------------------------------------------------------
     Meta ViewContent.

     Shopify's web pixel cannot fire this: product_viewed only fires on a
     product template and this is a page. Without it the campaign buying this
     traffic has no product-level signal and, worse, no audience to retarget —
     see the note on the pixel base code in layout/st-stripe.liquid.

     content_ids are BARE variant ids because that is what `retailer_id` is in
     the Meta catalog this store's DPA pulls from (verified 2026-07-26; see
     cloudflare/yellowlemon-meta.js). One representative IN-STOCK variant per
     colourway, not every variant: 13 colourways x 8 sizes would be ~100 ids,
     which buries the signal and tells Meta nothing extra.

     `value` is the lowest price a buyer can actually pay, so it matches the
     "from Tk 1,090" the ad promises. Out-of-stock chips are skipped for both,
     or the page would advertise a price nobody can buy at. Prices are minor
     units in the markup, hence /100 — getting that wrong is a 100x error in
     every reported conversion value.
     ---------------------------------------------------------------------- */
  (function () {
    if (!window.stTrack) return;

    var cards = root.querySelectorAll('[data-card]');
    var ids = [];
    var lowest = 0;

    for (var i = 0; i < cards.length; i++) {
      var chips = cards[i].querySelectorAll('[data-variant]');
      var picked = '';
      for (var j = 0; j < chips.length; j++) {
        if (chips[j].getAttribute('data-out') === 'true') continue;
        var price = Number(chips[j].getAttribute('data-price')) || 0;
        if (price > 0 && (lowest === 0 || price < lowest)) lowest = price;
        if (!picked) picked = chips[j].getAttribute('data-variant') || '';
      }
      if (picked) ids.push(String(picked));
    }

    if (!ids.length) return;

    window.stTrack('ViewContent', {
      content_type: 'product',
      content_ids: ids,
      content_name: CFG.contentName,
      content_category: CFG.contentCategory,
      value: lowest / 100,
      currency: 'BDT'
    });
  })();

  /* ------------------------------------------------------------------------
     Bangla copy.

     English is NOT duplicated here — it is harvested from the rendered DOM at
     boot, so the markup stays the single source of truth for it and the two can
     never drift. Only Bangla lives in this table.

     `{n}` is the live colourway count and `{in}` / `{out}` the delivery
     charges. They are substituted at apply time from data attributes Liquid
     wrote onto #st-root, so a number can never be baked into a translation and
     then quietly go stale — which is exactly how a page ends up advertising a
     count or a delivery charge that is no longer true.
     ---------------------------------------------------------------------- */
  var BN = {
    'nav.shop': 'শপ',

    'hero.eyebrow': 'নিউ অ্যারাইভাল',
    'hero.h1a': 'প্রিমিয়াম',
    'hero.h1b': 'স্ট্রাইপ',
    'hero.h1c': 'শার্ট',
    'hero.lead': '{n}টি কালার কম্বিনেশনে ক্লাসিক স্ট্রাইপ। ১০০% কটন, এক্সপোর্ট-কোয়ালিটি ফিনিশিং, আর ডাউন-বাটন কলার যা সারাদিন শেপ ধরে রাখে।',
    'hero.from': 'শুরু',
    'hero.cta': 'সব কালার দেখুন',
    'hero.cta2': 'সাইজ চার্ট',
    'hero.t1': '১০০% কটন',
    'hero.t2': 'S — 6XL',
    'hero.t3': 'ক্যাশ অন ডেলিভারি',

    'cw.eyebrow': 'কালারওয়ে',
    'cw.h2': '{n}টি স্ট্রাইপ থেকে বেছে নিন',
    'cw.lead': 'প্রতিটি শার্টই আলাদা একটি কালার কম্বিনেশন — সাইজ বেছে নিতে যেকোনোটিতে ট্যাপ করুন।',

    'q.eyebrow': 'কনস্ট্রাকশন',
    'q.h2': 'এক্সপোর্ট অর্ডারের মতো করে তৈরি',
    'q.f1h': '১০০% কটন',
    'q.f1p': 'ঢাকার গরমেও ব্রিদেবল, আর এতটাই আরামদায়ক যে সকাল থেকে রাত পর্যন্ত পরে থাকলেও অস্বস্তি লাগবে না।',
    'q.f2h': 'ডাউন-বাটন কলার',
    'q.f2p': 'কলার বাটন-ডাউন, তাই ব্লেজারের নিচে সমান বসে আর একা পরলেও সুন্দর দেখায়। প্রতিটি বাটনে রয়েছে আমাদের ব্র্যান্ডিং।',
    'q.f3h': 'কাফ, কলার, বক্স প্লেট',
    'q.f3p': 'পুরো শার্টজুড়ে এক্সপোর্ট-কোয়ালিটি স্টিচিং ও ফিনিশিং — কাফ, কলার আর পেছনের বক্স প্লেট, সবকিছুতেই সমান যত্ন।',
    'q.f4h': 'বাবলস নেই, রিঙ্কেল নেই',
    'q.f4p': 'ফ্যাব্রিক সমান থাকে, সমানই থাকবে — এমনকি ওয়াশ করার পরেও, যেখানে বেশিরভাগ শার্ট ধরা পড়ে যায়।',
    'q.f5h': 'প্রিমিয়াম অ্যাক্সেসরিজ',
    'q.f5p': 'বাটন, সুতা আর ইন্টারলাইনিং — সবকিছুই কাপড়ের মতো একই মানের, কারণ এগুলোই শার্টটাকে টিকিয়ে রাখে।',
    'q.f6h': 'যেকোনো অকেশনে',
    'q.f6p': 'অফিস, ক্যাজুয়াল হ্যাংআউট, কিংবা এর মাঝের যেকোনো উপলক্ষ। ফরমাল করার মতো যথেষ্ট টেইলরড, আবার না করলেও সমান স্বাচ্ছন্দ্য।',

    'qr.h': 'নিজেই যাচাই করে নিন',
    'qr.p': 'প্রতিটি শার্টে রয়েছে একটি কিউআর কোড। স্ক্যান করলেই আপনি সেই শার্টের নিজস্ব পেজে চলে যাবেন আমাদের ওয়েবসাইটে — যাতে আপনি নিশ্চিত হতে পারেন, যা কিনেছেন সেটাই আমরা পাঠিয়েছি।',

    'sz.eyebrow': 'সাইজ',
    'sz.h2': 'S থেকে 6XL, চেস্ট ৪১″ থেকে ৫৮″',
    'sz.lead': 'মাপগুলো শার্টের নিজের, ইঞ্চিতে দেওয়া। সব কালারে সব সাইজ নেই — উপরের প্রতিটি কার্ডে এখন কোন সাইজগুলো স্টকে আছে তা দেওয়া রয়েছে।',
    'sz.c0': 'সাইজ',
    'sz.c1': 'চেস্ট',
    'sz.c2': 'কোমর',
    'sz.c3': 'নিচের অংশ',
    'sz.c4': 'লম্বা',
    'sz.c5': 'কলার',
    'sz.c6': 'কাঁধ',
    'sz.c7': 'হাতা',
    'sz.c8': 'ফিট',
    'sz.hint': 'সব মাপ দেখতে টেবিলটি পাশে স্ক্রল করুন →',

    'close.h': 'অর্ডার করতে প্রস্তুত?',
    'close.p': 'সারা বাংলাদেশে ক্যাশ অন ডেলিভারি। ঢাকার ভেতরে ডেলিভারি {in}, ঢাকার বাইরে {out}।',
    'close.cta': 'কালার বেছে নিন',
    'close.cta2': 'সব শার্ট দেখুন',

    'sheet.eyebrow': 'আপনার পছন্দ',
    'sheet.size': 'সাইজ',
    'sheet.qty': 'পরিমাণ',
    'sheet.name': 'পুরো নাম',
    'sheet.phone': 'মোবাইল নম্বর',
    'sheet.addr': 'সম্পূর্ণ ঠিকানা',
    'sheet.city': 'শহর / জেলা',
    'sheet.area': 'ডেলিভারি এলাকা',
    'sheet.inside': 'ঢাকার ভেতরে',
    'sheet.outside': 'ঢাকার বাইরে',
    'sheet.note': 'ডেলিভারি চার্জ চেকআউটে যোগ হবে। ক্যাশ অন ডেলিভারি রয়েছে।',
    'sheet.go': 'চেকআউটে যান',
    'sheet.chart': 'সাইজ চার্ট',
    'sheet.chartnote': 'শার্টের নিজের মাপ, ইঞ্চিতে।',
    'sheet.about': 'প্রোডাক্ট ডিটেইলস',
    'sheet.line': 'লাইন টোটাল',
    'sheet.add': 'ব্যাগে যোগ করুন',
    'sheet.buy': 'এখনই কিনুন',

    'bag.title': 'আপনার ব্যাগ',
    'bag.empty': 'আপনার ব্যাগ খালি।',
    'bag.browse': 'কালারওয়ে দেখুন',
    'bag.details': 'ডেলিভারির তথ্য',
    'bag.sub': 'সাবটোটাল',
    'bag.ship': 'ডেলিভারি',
    'bag.total': 'সর্বমোট',
    'bag.go': 'চেকআউট',
    'bag.go2': 'অর্ডার নিশ্চিত করুন',
    /* Corrected 2026-09-18: this line used to tell cash-on-delivery buyers to
       choose Free Delivery, which is exactly what makes the store's
       hide-cod-free-delivery Function hide COD at the payment step. This table
       is the fallback for pages that ship no Bangla of their own — in practice
       the stripe page. */
    'bag.note': 'ক্যাশ অন ডেলিভারিতে নিতে চাইলে চেকআউটে ডেলিভারি মেথড হিসেবে Inside Dhaka বা Outside Dhaka বেছে নিন। Free Delivery মানে অনলাইনে পেমেন্ট।',
    'bag.size': 'সাইজ',

    'dock.inbag': 'আপনার ব্যাগে',
    'dock.view': 'ব্যাগ দেখুন',
    'toast.added': 'ব্যাগে যোগ হয়েছে',
    'toast.removed': 'সরানো হয়েছে',

    'sheet.errSize': 'একটি সাইজ বেছে নিন।',
    'sheet.errName': 'আপনার নাম লিখুন।',
    'sheet.errPhone': 'সঠিক মোবাইল নম্বর দিন (যেমন ০১৭XXXXXXXX)।',
    'sheet.errAddr': 'সম্পূর্ণ ঠিকানা লিখুন।',
    'sheet.errCity': 'শহর বা জেলার নাম লিখুন।',

    'app.eyebrow': 'শার্টোলজি অ্যাপ',
    'app.h': 'অ্যাপে প্রতিটি অর্ডারে ১৫% ছাড়',
    'app.p': 'ছাড়টি নিজে থেকেই যোগ হয়ে যায় — কোনো কোড লিখতে হয় না। সেই সাথে রিয়েল-টাইম কুরিয়ার ট্র্যাকিং, রিওয়ার্ড পয়েন্ট যা ভাউচার হিসেবে খরচ করা যায়, আর অনলাইনে পেমেন্ট করলে ফ্রি ডেলিভারি।',
    'app.off': 'ছাড়',
    'app.gp1': 'পাবেন',
    'app.gp2': 'Google Play',
    'app.as1': 'ডাউনলোড করুন',
    'app.as2': 'App Store',

    'foot.android': 'অ্যান্ড্রয়েড অ্যাপ',
    'foot.ios': 'আইফোন অ্যাপ',
    'foot.home': 'হোম',
    'foot.shop': 'সব শার্ট',
    'foot.cart': 'কার্ট',

    'mq.1': '১০০% কটন',
    'mq.2': 'এক্সপোর্ট কোয়ালিটি স্টিচিং',
    'mq.3': 'ডাউন-বাটন কলার',
    'mq.4': 'S থেকে 6XL',
    'mq.5': 'ক্যাশ অন ডেলিভারি',

    'dock.lab': 'স্ট্রাইপ শার্ট',
    'dock.cta': 'বেছে নিন'
  };

  /* English is normally harvested from the rendered DOM, so the markup stays
     its single source of truth. These strings are the exception: they are only
     ever shown by the script, so they appear in no element to harvest from —
     without them the sheet renders the raw i18n key at a validation error. */
  var EN = {
    'sheet.errSize': 'Choose a size first.',
    'sheet.errName': 'Please enter your name.',
    'sheet.errPhone': 'Enter a valid Bangladeshi mobile number (e.g. 017XXXXXXXX).',
    'sheet.errAddr': 'Please enter your full address.',
    'sheet.errCity': 'Please enter your city or district.',
    'sheet.errEmail': 'That email does not look right — correct it or leave it empty.',
    'bag.size': 'Size',
    'bag.go2': 'Place order',
    'dock.inbag': 'In your bag',
    'dock.view': 'View bag',
    'toast.added': 'Added to your bag',
    'toast.removed': 'Removed'
  };
  /* ------------------------------------------------------------------------
     Per-drop Bangla.

     The table above is the stripe page's. Every other drop ships its own in a
     <script type="application/json" data-st-bn> block, written by
     snippets/sl-landing.liquid from that drop's config section.

     `data-bn-strict="true"` REPLACES the table rather than merging into it,
     which is what a non-stripe page wants: a key it forgets then falls back to
     the English harvested from its own markup, instead of quietly showing a
     Bangla sentence about stripe shirts. A block that will not parse is
     treated the same way, for the same reason.
     ---------------------------------------------------------------------- */
  (function () {
    var el = root.querySelector('[data-st-bn]');
    if (!el) return;

    var table;
    try {
      table = JSON.parse(el.textContent || '{}');
    } catch (e) {
      if (CFG.bnStrict) BN = {};
      return;
    }
    if (!table || typeof table !== 'object') {
      if (CFG.bnStrict) BN = {};
      return;
    }

    if (CFG.bnStrict) { BN = table; return; }
    for (var k in table) {
      if (Object.prototype.hasOwnProperty.call(table, k)) BN[k] = table[k];
    }
  })();

  var lang = 'en';

  var COUNT = root.getAttribute('data-count') || '';
  /* Money strings, already formatted by Liquid in the shop's own money_format
     (currently "Tk"), so Bangla never hardcodes a currency symbol the store
     might not be using. */
  var SHIP_IN = root.getAttribute('data-ship-in') || '';
  var SHIP_OUT = root.getAttribute('data-ship-out') || '';

  /* The largest size still in stock, and the waist that goes with it. The
     Liquid has already resolved these into the rendered English; the Bangla
     table keeps them as placeholders, so the same two values have to be here
     for the language swap. A page that passes no `size_waist` leaves them
     empty and simply has no copy that uses them. */
  var TOP_SIZE = root.getAttribute('data-top-size') || '';
  var TOP_WAIST = root.getAttribute('data-top-waist') || '';

  var BN_DIGITS = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];

  function toBn(str) {
    return String(str).replace(/[0-9]/g, function (d) { return BN_DIGITS[+d]; });
  }

  function fill(str) {
    return str
      .replace(/\{n\}/g, lang === 'bn' ? toBn(COUNT) : COUNT)
      .replace(/\{in\}/g, lang === 'bn' ? toBn(SHIP_IN) : SHIP_IN)
      .replace(/\{out\}/g, lang === 'bn' ? toBn(SHIP_OUT) : SHIP_OUT)
      /* A size label is not a number to convert — "XXL" stays "XXL" in Bangla,
         while the waist that goes with it is a measurement and does. */
      .replace(/\{top\}/g, TOP_SIZE)
      .replace(/\{waist\}/g, lang === 'bn' ? toBn(TOP_WAIST) : TOP_WAIST);
  }

  /* One dictionary lookup, at the scope everything can reach it.

     applyLang() has this inline and the bag has its own T(); the hero badge and
     the size-sheet heading need it too, because on an offers page those two are
     set from JAVASCRIPT rather than rendered by Liquid, so they are the only
     visible strings applyLang cannot reach on its own. */
  function dict(key, fallback) {
    if (!key) return fallback;
    var v = (lang === 'bn' && BN[key] != null) ? BN[key] : EN[key];
    return v == null ? fallback : fill(v);
  }

  /* Harvest the rendered English once, before anything has been swapped. */
  function harvest() {
    var nodes = root.querySelectorAll('[data-i18n], [data-i18n-html]');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      var htmlKey = n.getAttribute('data-i18n-html');
      var key = htmlKey || n.getAttribute('data-i18n');
      if (key && EN[key] == null) EN[key] = htmlKey ? n.innerHTML : n.textContent;
    }
    /* Numerals: remember the Latin original so switching back is lossless. */
    var nums = root.querySelectorAll('[data-bn-num]');
    for (var j = 0; j < nums.length; j++) {
      nums[j].setAttribute('data-num-en', nums[j].textContent);
    }
  }

  function applyLang() {
    var nodes = root.querySelectorAll('[data-i18n], [data-i18n-html]');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      var htmlKey = n.getAttribute('data-i18n-html');
      var key = htmlKey || n.getAttribute('data-i18n');
      if (!key) continue;
      var val = lang === 'bn' && BN[key] != null ? BN[key] : EN[key];
      if (val == null) continue;
      val = fill(val);
      if (htmlKey) n.innerHTML = val; else n.textContent = val;
    }

    var nums = root.querySelectorAll('[data-bn-num]');
    for (var j = 0; j < nums.length; j++) {
      var orig = nums[j].getAttribute('data-num-en');
      if (orig == null) continue;
      nums[j].textContent = lang === 'bn' ? toBn(orig) : orig;
    }

    document.documentElement.setAttribute('data-lang', lang);

    var btns = root.querySelectorAll('[data-lang-btn]');
    for (var k = 0; k < btns.length; k++) {
      btns[k].setAttribute('aria-pressed', btns[k].getAttribute('data-lang-btn') === lang ? 'true' : 'false');
    }
  }

  function setLang(next) {
    lang = next === 'bn' ? 'bn' : 'en';
    applyLang();
    try { localStorage.setItem('st-lang', lang); } catch (e) {}
  }

  harvest();

  root.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-lang-btn]') : null;
    if (!btn) return;
    setLang(btn.getAttribute('data-lang-btn'));
  });

  var saved = 'en';
  try { saved = localStorage.getItem('st-lang') || 'en'; } catch (e) {}
  setLang(saved === 'bn' ? 'bn' : 'en');

  /* ------------------------------------------------------------------------
     Reveal on scroll. Skipped entirely for reduced-motion visitors and where
     IntersectionObserver is missing — in both cases everything is shown at
     once rather than left invisible, which is the failure that would make the
     page look empty.
     ---------------------------------------------------------------------- */
  var reveals = root.querySelectorAll('.st-rv');
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!('IntersectionObserver' in window) || reduced) {
    for (var r = 0; r < reveals.length; r++) reveals[r].setAttribute('data-in', 'skip');
  } else {
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        entries[i].target.setAttribute('data-in', 'true');
        io.unobserve(entries[i].target);
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    for (var m = 0; m < reveals.length; m++) io.observe(reveals[m]);
  }

  /* ------------------------------------------------------------------------
     The video band.

     Rendered by snippets/sl-landing-video.liquid, which only a drop that sets
     a video gets. The querySelectorAll below finds nothing on the stripe and
     suede pages, so this whole block returns immediately there — the same
     opt-in shape as `data-reveal-sizes` and `data-hero-buy`.

     The markup ships with preload="none" and no `controls`, which means that
     until something here calls play() the page has paid for a poster image and
     nothing else. That is the point: a 15-second reel is 2-4MB, more than the
     rest of the page put together, and a visitor who never scrolls to the band
     must never pay for it.
     ---------------------------------------------------------------------- */
  (function () {
    var vids = root.querySelectorAll('[data-vid]');
    if (!vids.length) return;

    /* Reduced motion means do not start anything by itself. The video is still
       there to be watched, so it gets native controls and waits to be asked —
       hiding it, or leaving a poster with no way to play it, would both be
       worse than the motion. `reduced` is the reveal block's answer,
       deliberately: one answer to that question per page. */
    var auto = !reduced && 'IntersectionObserver' in window;

    /* Only one video may have sound. Two 9:16 loops sit side by side, and
       unmuting the second while the first is still audible is the kind of thing
       a visitor fixes by closing the tab. */
    var loud = null;

    function wrapOf(el) {
      return el.closest ? el.closest('[data-vid]') : null;
    }

    function setSound(wrap, el, on) {
      el.muted = !on;
      var btn = wrap.querySelector('[data-vid-sound]');
      if (btn) {
        btn.setAttribute('aria-pressed', on ? 'false' : 'true');
        btn.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on');
      }
      if (on) loud = el;
      else if (loud === el) loud = null;
    }

    /* Autoplay can be refused, and it is refused differently everywhere: a
       muted inline video is allowed by every current mobile browser, but a data
       saver, a battery saver or a webview embedder can still say no. play()
       rejects in that case, and without this the visitor is left with a poster
       they cannot start, because there are no controls to fall back on.

       `data-vid-manual` hides the sound button (see sl-landing.css) so the
       native control bar is not stacked on top of it. */
    function manual(wrap, el) {
      if (wrap.getAttribute('data-vid-manual') === 'true') return;
      wrap.setAttribute('data-vid-manual', 'true');
      el.controls = true;
    }

    function play(wrap, el) {
      var p;
      try { p = el.play(); } catch (e) { manual(wrap, el); return; }
      if (p && typeof p.catch === 'function') {
        p.catch(function () { manual(wrap, el); });
      }
    }

    /* The frames the observer below arbitrates between, in document order. */
    var observed = [];

    function wire(wrap) {
      var el = wrap.querySelector('[data-vid-el]');
      if (!el) return;

      if (!auto) manual(wrap, el);

      /* Tap the frame to pause or resume. The sound button is inside the frame
         and must not also toggle playback, so it is excluded here rather than
         by stopPropagation in its own handler — that way a control added later
         is not silently swallowing taps. */
      wrap.addEventListener('click', function (e) {
        var onBtn = e.target.closest ? e.target.closest('[data-vid-sound]') : null;
        if (onBtn) return;
        if (el.paused) {
          /* A tap wins over the arbiter: whatever it was playing gives way, or
             the next scroll callback would pause the frame just tapped. */
          if (current && current !== wrap) {
            var other = current.querySelector('[data-vid-el]');
            if (other) other.pause();
          }
          current = wrap;
          play(wrap, el);
        } else {
          el.pause();
          if (current === wrap) current = null;
        }
      });

      var btn = wrap.querySelector('[data-vid-sound]');
      if (btn) {
        btn.addEventListener('click', function () {
          var turningOn = el.muted;
          if (turningOn && loud && loud !== el) {
            /* Mute whoever is currently loud, and repaint THEIR button. */
            var other = wrapOf(loud);
            if (other) setSound(other, loud, false);
            else loud.muted = true;
          }
          setSound(wrap, el, turningOn);
          /* Unmuting a paused video should start it — the tap that unmuted it
             is the gesture the browser wanted, and asking for a second one
             reads as the button not working. */
          if (turningOn && el.paused) play(wrap, el);
        });
      }

      if (!auto) return;
      observed.push(wrap);
    }

    /* ONE video plays at a time: the most visible one.

       Playing every frame that happens to be on screen is what made the page
       scroll badly. Measured 2026-09-19 on the live page at 390px with the CPU
       throttled 4x, two 404x720 streams decoding side by side each DROPPED
       about 6% of their frames (5 and 4 of 73) — and a mid-range Android in
       Dhaka, which is what this page is built for, is slower than a throttled
       Mac. Decode cost is per stream, so the fix is to have fewer streams, not
       smaller ones: dropping to the 480p rendition would have cost quality on
       every device to solve a problem only the slow ones have.

       It is also better to watch. Three silent loops running at once compete
       with each other; one playing frame is what a reel row does everywhere.

       Ratios rather than a single threshold, because "most visible" is a
       comparison and a boolean cannot answer it. The list is coarse on purpose
       — every extra threshold is another callback during a scroll. */
    var ratios = [];
    var current = null;

    function pick() {
      var bestI = -1;
      var best = 0.3; /* below this nothing plays: a sliver is not watching */
      for (var i = 0; i < observed.length; i++) {
        if (ratios[i] > best) { best = ratios[i]; bestI = i; }
      }
      var winner = bestI < 0 ? null : observed[bestI];
      if (winner === current) return;

      /* Pause the outgoing one first, so the two are never decoding together
         even for a frame — which is the whole point of this. */
      if (current) {
        var prevEl = current.querySelector('[data-vid-el]');
        if (prevEl) {
          prevEl.pause();
          /* Leaving the screen gives up the sound too. A loop still talking
             from three screens up has no way to be stopped except by scrolling
             back to find it. */
          if (loud === prevEl) setSound(current, prevEl, false);
        }
      }
      current = winner;
      if (current) {
        var el = current.querySelector('[data-vid-el]');
        if (el) play(current, el);
      }
    }

    for (var v = 0; v < vids.length; v++) wire(vids[v]);

    if (auto && observed.length) {
      var vio = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var idx = observed.indexOf(entries[i].target);
          if (idx >= 0) ratios[idx] = entries[i].intersectionRatio;
        }
        pick();
      }, { threshold: [0, 0.3, 0.6, 0.9] });

      for (var o = 0; o < observed.length; o++) {
        ratios[o] = 0;
        vio.observe(observed[o]);
      }
    }

    /* A video keeps playing when the page is hidden — a backgrounded tab, or
       the moment the buyer is handed off to the Shopify checkout. Nothing on
       screen explains where the sound is coming from at that point. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) return;
      for (var i = 0; i < vids.length; i++) {
        var el = vids[i].querySelector('[data-vid-el]');
        if (!el || el.paused) continue;
        el.pause();
        if (loud === el) setSound(vids[i], el, false);
      }
    });
  })();

  /* ------------------------------------------------------------------------
     Nav border + mobile dock, both driven off one scroll listener.

     The dock appears once the hero's CTA has scrolled away, so it never
     duplicates a button already on screen.
     ---------------------------------------------------------------------- */
  var nav = root.querySelector('[data-nav]');
  var dock = root.querySelector('[data-dock]');
  var hero = root.querySelector('.st-hero__cta');
  var ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      if (nav) nav.setAttribute('data-stuck', y > 8 ? 'true' : 'false');

      if (dock) {
        var past = true;
        if (hero) past = hero.getBoundingClientRect().bottom < 0;
        /* Hide again at the very bottom so it never sits on the final CTA. */
        var atEnd = (window.innerHeight + y) >= (document.body.scrollHeight - 140);
        dock.setAttribute('data-show', past && !atEnd ? 'true' : 'false');
      }
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();

  /* ------------------------------------------------------------------------
     Theme.

     No stored value means "follow the OS", which is the state the page ships
     in — the toggle only takes over once the visitor has actually expressed a
     preference. Reading the CURRENT computed state before flipping is what
     makes the first tap always do the visible thing, whichever way the OS
     happens to be set.
     ---------------------------------------------------------------------- */
  var themeBtn = root.querySelector('[data-theme-btn]');

  function currentTheme() {
    var forced = document.documentElement.getAttribute('data-theme');
    if (forced === 'dark' || forced === 'light') return forced;
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }

  if (themeBtn) {
    themeBtn.addEventListener('click', function () {
      var next = currentTheme() === 'dark' ? 'light' : 'dark';
      document.documentElement.setAttribute('data-theme', next);
      try { localStorage.setItem('st-theme', next); } catch (e) {}
      themeBtn.setAttribute('aria-pressed', next === 'dark' ? 'true' : 'false');
      var metas = document.querySelectorAll('meta[name="theme-color"]');
      for (var m = 0; m < metas.length; m++) {
        metas[m].setAttribute('content', next === 'dark' ? '#0f1218' : '#f8f7f3');
        metas[m].removeAttribute('media');
      }
    });
  }

  /* ------------------------------------------------------------------------
     Hero colourway cycle.

     Two <img> layers, not one per colourway: the next image is loaded into
     whichever layer is hidden and the two swap. That ships one image instead of
     thirteen, which is the difference between a fast hero and a 1 MB one on a
     Bangladeshi mobile connection.

     Auto-advance stops permanently the moment the visitor picks a chip — once
     they are steering, moving it under them is just rude. It also pauses while
     the hero is off screen, and never starts at all under reduced-motion.
     ---------------------------------------------------------------------- */
  var stack = root.querySelector('[data-stack]');
  var chips = [].slice.call(root.querySelectorAll('[data-sw]'));
  var tag = root.querySelector('[data-hero-code]');

  if (stack && chips.length) {
    var layers = [stack.querySelector('[data-layer="a"]'), stack.querySelector('[data-layer="b"]')];
    var front = 0;
    var idx = 0;
    var timer = null;
    var userPicked = false;
    var visible = true;
    var DWELL = 3600;

    chips[0].setAttribute('data-on', 'true');

    /* A chip may carry two widths — data-src for a phone, data-src-lg for a
       wider screen. A page whose chips carry only data-src (the stripe page)
       keeps using it. The 1000px file is 300KB+ for these photographs while a
       phone shows the hero about 340px wide, so this is the single biggest
       weight saving available on the page. */
    function chipSrc(c) {
      if (!c) return '';
      var lg = c.getAttribute('data-src-lg');
      if (lg && window.innerWidth >= 700) return lg;
      return c.getAttribute('data-src') || lg || '';
    }

    function preload(i) {
      var c = chips[i];
      if (!c) return;
      var im = new Image();
      im.src = chipSrc(c);
    }

    function show(i, viaUser) {
      if (i === idx) return;
      var chip = chips[i];
      if (!chip) return;
      var src = chipSrc(chip);
      var back = layers[1 - front];
      if (!back) return;

      /* Strip srcset/sizes before assigning src.

         The first layer is rendered WITH a srcset so the initial photograph —
         the one the LCP is measured on — comes down at a phone-sized width. But
         srcset takes precedence over src for the rest of the element's life, so
         once the crossfade assigned a new src to that layer the browser kept
         serving the ORIGINAL candidate: layer A stayed on the first colourway
         for ever while the badge advanced, and in the Facebook in-app browser
         it rendered as an empty box.

         Seen on live ad traffic 2026-09-18. Removing the attributes on first
         swap keeps the initial-load saving and makes every later swap honest. */
      if (back.getAttribute('srcset')) {
        back.removeAttribute('srcset');
        back.removeAttribute('sizes');
      }

      var apply = function () {
        layers[front].classList.remove('is-on');
        back.classList.add('is-on');
        front = 1 - front;
        idx = i;
        for (var k = 0; k < chips.length; k++) {
          if (k === i) chips[k].setAttribute('data-on', 'true');
          else chips[k].removeAttribute('data-on');
        }
        if (tag) {
          /* The badge shows a LABEL and matches by a CODE, and on a Bangla
             offers page those are different strings. Translating the text alone
             broke the hero tap, because heroCard() used to read this element's
             textContent to find the card — so the code now travels as an
             attribute and the text is free to be Bangla.

             `data-i18n` is set as well as the text so that a later language
             switch repaints it correctly: applyLang() works off that attribute
             and would otherwise leave whatever the last crossfade wrote. */
          var codeK = chip.getAttribute('data-code-key');
          tag.setAttribute('data-code', chip.getAttribute('data-code') || '');
          if (codeK) {
            tag.setAttribute('data-i18n', codeK);
            tag.textContent = dict(codeK, chip.getAttribute('data-code') || '');
          } else {
            tag.textContent = chip.getAttribute('data-code') || '';
          }
        }
        preload((i + 1) % chips.length);
      };

      if (back.getAttribute('src') === src && back.complete) { apply(); return; }
      stack.setAttribute('data-loading', 'true');
      var done = function () { stack.removeAttribute('data-loading'); apply(); };
      back.onload = done;
      back.onerror = function () { stack.removeAttribute('data-loading'); };
      back.setAttribute('src', src);
      if (viaUser) back.removeAttribute('aria-hidden');
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    function start() {
      if (reduced || userPicked || timer || chips.length < 2) return;
      timer = setInterval(function () {
        if (!visible) return;
        show((idx + 1) % chips.length);
      }, DWELL);
    }

    var warmed = {};
    function warm(i) {
      if (warmed[i]) return;
      warmed[i] = 1;
      preload(i);
    }

    for (var ci = 0; ci < chips.length; ci++) {
      (function (i) {
        var c = chips[i];
        c.addEventListener('click', function (e) {
          e.preventDefault();      // the href is the no-JS fallback only
          userPicked = true;
          stop();
          show(i, true);
        });
        c.addEventListener('touchstart', function () { warm(i); }, { passive: true });
        c.addEventListener('pointerenter', function () { warm(i); });
      })(ci);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
      }, { threshold: 0.15 }).observe(stack);
    }

    /* Nothing is prefetched until the photograph the visitor is actually looking
       at has arrived.

       Traced 2026-09-17 on a throttled mid-range Android: the hero's own file
       started at 870ms and did not finish until 4603ms, because at 1859ms this
       preload pulled the NEXT colourway — another 199KB — across the same
       connection while the visible one was still in flight. Prefetching for a
       crossfade nobody has seen yet, ahead of the image that IS on screen, is
       the wrong way round.

       The cycle starts from the same point, so the first crossfade still
       happens on time. */
    function beginCycle() { preload(1); start(); }

    /* The rotation stops the moment a finger arrives.

       Once the photograph is tappable the 3.6s cycle becomes a hazard: a thumb
       aims at the shirt it can see and the picture changes on the way down, so
       the sheet opens on a colourway the buyer never chose. Measured on the
       live page: five reads 1.3s apart gave "Aqua 220, Aqua 220, Aqua 220, Pink
       210, Pink 210".

       `pointerdown` fires before the click, so stopping here freezes what the
       buyer is looking at before the tap resolves. */
    if (root.querySelector('[data-hero-buy]')) {
      stack.addEventListener('pointerdown', function () { userPicked = true; stop(); }, { passive: true });
    }

    /* And it stops for good once a sheet is open — the hero is behind a veil at
       that point, so rotating only wastes image fetches and, worse, leaves a
       different shirt on screen when the sheet closes than the one the buyer
       just added (observed: Dusty Pink 222 -> RLS Beige 151). */
    root.addEventListener('st:sheet-open', function () { userPicked = true; stop(); });

    var firstLayer = layers[0];
    if (firstLayer && firstLayer.complete && firstLayer.naturalWidth) {
      window.setTimeout(beginCycle, 500);
    } else if (firstLayer) {
      firstLayer.addEventListener('load', function () { window.setTimeout(beginCycle, 500); }, { once: true });
      /* a hero that fails still gets a working rail, just a beat later */
      firstLayer.addEventListener('error', function () { window.setTimeout(beginCycle, 1500); }, { once: true });
    } else {
      beginCycle();
    }
  }

  /* ------------------------------------------------------------------------
     Stagger + scroll progress.

     `--i` is the element's position within its own group, so a row of cards
     arrives as a run instead of all at once. Grouped by parent, otherwise the
     last card on the page would wait a second and a half for its turn.
     ---------------------------------------------------------------------- */
  var groups = {};
  for (var g = 0; g < reveals.length; g++) {
    var par = reveals[g].parentNode;
    var key = par.className || 'x';
    groups[key] = groups[key] || 0;
    reveals[g].style.setProperty('--i', Math.min(groups[key], 8));
    groups[key]++;
  }

  var prog = root.querySelector('[data-prog]');
  if (prog) {
    var progTick = false;
    var onProg = function () {
      if (progTick) return;
      progTick = true;
      window.requestAnimationFrame(function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        var y = window.pageYOffset || document.documentElement.scrollTop;
        prog.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, y / h) : 0) + ')';
        progTick = false;
      });
    };
    window.addEventListener('scroll', onProg, { passive: true });
    window.addEventListener('resize', onProg, { passive: true });
    onProg();
  }

  /* ------------------------------------------------------------------------
     Size sheet -> Shopify checkout.

     The hand-off is a cart permalink, /cart/<variantId>:<qty> with checkout[…]
     parameters, so the buyer lands on the store's REAL checkout with their
     address prefilled — and every Shopify Function the store relies on (COD
     hidden on Free Delivery, "Inside Dhaka" hidden outside Dhaka, phone/country
     validation) still runs. Creating the order here instead would bypass all of
     them.
     ---------------------------------------------------------------------- */
  /* ------------------------------------------------------------------------
     The bag.

     A real multi-line cart held in localStorage, so several colourways and
     sizes can be assembled in one order and survive a reload. Checkout is a
     single Shopify cart permalink carrying every line —
     /cart/<v1>:<q1>,<v2>:<q2>?checkout[...] — which lands the buyer on the
     store's REAL checkout with the whole bag and their address prefilled.

     That route is deliberate. Building the order here instead (the way the
     Yellow Lemon worker pages must, having no Shopify checkout to hand off to)
     would bypass every Shopify Function the store depends on: COD hidden on
     Free Delivery, "Inside Dhaka" hidden outside Dhaka, and phone/country
     validation.
     ---------------------------------------------------------------------- */
  var sheet = root.querySelector('[data-sheet]');
  var bag   = root.querySelector('[data-bag]');

  if (sheet && bag) {
    var CART_KEY = CFG.cartKey;
    var MAX_QTY = 10;

    /* Same rule the validate-phone-by-country Function enforces at checkout.
       Anything looser here only moves the rejection to a screen the buyer
       reaches believing they are finished. */
    var BD_PHONE = /^(\+?880|0)1[3-9]\d{8}$/;

    var SAMPLE = root.getAttribute('data-money-sample') || 'Tk 1,000';
    var mm = SAMPLE.match(/^(.*?)[\d.,]+(.*)$/);
    var MPRE = mm ? mm[1] : '';
    var MPOST = mm ? mm[2] : '';
    var SHIP_IN_N = Number(root.getAttribute('data-ship-in-n')) || 0;
    var SHIP_OUT_N = Number(root.getAttribute('data-ship-out-n')) || 0;

    function money(cents) {
      var out = MPRE + Math.round(cents / 100).toLocaleString('en-US') + MPOST;
      return lang === 'bn' ? toBn(out) : out;
    }

    function num(n) { return lang === 'bn' ? toBn(n) : String(n); }

    /* ---- state ---- */

    var PENDING_KEY = CART_KEY + '-pending';
    var PENDING_TTL = 30 * 60 * 1000;

    var cart = [];
    try {
      var raw = JSON.parse(localStorage.getItem(CART_KEY));
      if (Array.isArray(raw)) cart = raw.filter(function (l) { return l && l.variant && l.qty > 0; });
    } catch (e) {}

    /* Coming BACK from the checkout restores the bag.

       The hand-off clears the bag so a buyer who completed an order does not
       return to a page insisting they still have one to finish. But the back
       button is how a buyer edits an order, and it was landing them on an empty
       bag: three shirts to find and add again before they could change one
       size.

       So the hand-off keeps a copy, and it is restored only for a genuine
       back/forward navigation within half an hour. A fresh visit, a new tab or
       a link clicked tomorrow all see an empty bag, as they should. */
    if (!cart.length) {
      try {
        /* navEntry, not nav: `var` is function-scoped, and this whole file is one
           IIFE, so `var nav` here silently reassigned the nav ELEMENT declared
           further up — after which every scroll threw "nav.setAttribute is not a
           function" and the header stopped reacting to scroll. Caught on the
           live page, not in any local run. */
        var navEntry = performance.getEntriesByType('navigation')[0];
        var cameBack = navEntry ? navEntry.type === 'back_forward' : false;
        var pending = JSON.parse(localStorage.getItem(PENDING_KEY) || 'null');
        if (cameBack && pending && Array.isArray(pending.lines) && (Date.now() - pending.at) < PENDING_TTL) {
          cart = pending.lines.filter(function (l) { return l && l.variant && l.qty > 0; });
          if (cart.length) localStorage.setItem(CART_KEY, JSON.stringify(cart));
        }
      } catch (e) {}
    }

    function persist() {
      try { localStorage.setItem(CART_KEY, JSON.stringify(cart)); } catch (e) {}
    }

    function count() {
      var n = 0;
      for (var i = 0; i < cart.length; i++) n += cart[i].qty;
      return n;
    }

    function subtotal() {
      var t = 0;
      for (var i = 0; i < cart.length; i++) t += cart[i].price * cart[i].qty;
      return t;
    }

    function addLine(line) {
      for (var i = 0; i < cart.length; i++) {
        if (cart[i].variant === line.variant) {
          cart[i].qty = Math.min(MAX_QTY, cart[i].qty + line.qty);
          persist();
          return;
        }
      }
      cart.push(line);
      persist();
    }

    /* ---- elements ---- */

    var elBagN     = bag.querySelector('[data-bag-n]');
    var elLines    = bag.querySelector('[data-bag-lines]');
    var elEmpty    = bag.querySelector('[data-bag-empty]');
    var elFoot     = bag.querySelector('[data-bag-foot]');
    var elCta      = bag.querySelector('[data-bag-cta]');
    var elSub      = bag.querySelector('[data-bag-sub]');
    var elShip     = bag.querySelector('[data-bag-ship]');
    var elTotal    = bag.querySelector('[data-bag-total]');
    var elGo       = bag.querySelector('[data-bag-go]');
    var elBagErr   = bag.querySelector('[data-bag-err]');
    var elForm     = bag.querySelector('[data-order-form]');
    var badge      = root.querySelector('[data-bag-count]');
    var toastEl    = root.querySelector('[data-toast]');
    var dockLab    = root.querySelector('[data-dock-lab]');
    var dockAmt    = root.querySelector('[data-dock-amt]');
    var dockCta    = root.querySelector('[data-dock-cta]');

    var area = 'inside';
    var toastT = null;

    function toast(msg) {
      if (!toastEl) return;
      toastEl.textContent = msg;
      toastEl.setAttribute('data-show', 'true');
      window.clearTimeout(toastT);
      toastT = window.setTimeout(function () { toastEl.setAttribute('data-show', 'false'); }, 2200);
    }

    function T(key) { return (lang === 'bn' && BN[key]) ? BN[key] : (EN[key] || key); }

    /* ---- render ---- */

    function renderBag() {
      var n = count();

      if (badge) {
        badge.textContent = num(n);
        badge.hidden = n === 0;
      }
      if (elBagN) elBagN.textContent = num(n);

      if (elEmpty) elEmpty.hidden = n > 0;
      if (elFoot) elFoot.hidden = n === 0;
      if (elCta) elCta.hidden = n === 0;
      if (elForm && n === 0) elForm.hidden = true;

      /* The dock stops advertising a starting price once there is a bag to
         finish — at that point the useful action is checkout, not browsing. */
      if (dockLab && dockAmt && dockCta) {
        if (n > 0) {
          dockLab.textContent = T('dock.inbag');
          dockAmt.textContent = num(n) + ' · ' + money(subtotal());
          dockCta.textContent = T('dock.view');
          dockCta.setAttribute('data-open-bag', '1');
        } else {
          dockCta.removeAttribute('data-open-bag');
        }
      }

      if (!elLines) return;
      elLines.innerHTML = '';

      for (var i = 0; i < cart.length; i++) {
        var l = cart[i];
        var li = document.createElement('li');
        li.className = 'st-line';
        li.setAttribute('data-line', l.variant);
        li.innerHTML =
          '<img class="st-line__img" src="' + l.img + '" alt="" width="58" height="73" loading="lazy">' +
          '<span class="st-line__mid">' +
            '<span class="st-line__code"></span>' +
            '<span class="st-line__sz"></span>' +
            '<span class="st-line__p"></span>' +
          '</span>' +
          '<span class="st-line__right">' +
            '<button type="button" class="st-line__rm" data-rm aria-label="Remove">' +
              '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
            '</button>' +
            '<span class="st-line__qty">' +
              '<button type="button" class="st-line__qb" data-lq="-1" aria-label="Decrease">&minus;</button>' +
              '<span class="st-line__qn"></span>' +
              '<button type="button" class="st-line__qb" data-lq="1" aria-label="Increase">+</button>' +
            '</span>' +
          '</span>';
        /* textContent, not innerHTML, for anything derived from stored data. */
        li.querySelector('.st-line__code').textContent = dict(l.codeKey, l.code);
        li.querySelector('.st-line__sz').textContent = T('bag.size') + ' ' + l.size;
        li.querySelector('.st-line__p').textContent = money(l.price * l.qty);
        li.querySelector('.st-line__qn').textContent = num(l.qty);
        elLines.appendChild(li);
      }

      var sub = subtotal();
      var ship = (area === 'outside' ? SHIP_OUT_N : SHIP_IN_N) * 100;
      if (elSub) elSub.textContent = money(sub);
      if (elShip) elShip.textContent = money(ship);
      if (elTotal) elTotal.textContent = money(sub + ship);
    }

    function openBag() {
      /* The open bag IS the confirmation, and on a phone the toast lands right
         on top of the checkout button. Stand it down. */
      if (toastEl) toastEl.setAttribute('data-show', 'false');
      window.clearTimeout(toastT);
      bag.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
      renderBag();
    }

    function closeBag() {
      bag.setAttribute('data-open', 'false');
      document.body.style.overflow = '';
    }

    /* ---- size sheet ---- */

    var sBody  = sheet.querySelector('[data-sheet-sizes]');
    var sCode  = sheet.querySelector('[data-sheet-code]');
    var gMain  = sheet.querySelector('[data-gal-main]');
    var gStrip = sheet.querySelector('[data-gal-strip]');
    var sTotal = sheet.querySelector('[data-sheet-total]');
    var sErr   = sheet.querySelector('[data-sheet-err]');
    var qtyN   = sheet.querySelector('[data-qty-n]');

    var sel = null;
    var qty = 1;
    var lastFocus = null;

    function sheetTotal() {
      if (sTotal) sTotal.textContent = sel ? money(sel.price * qty) : '—';
      if (qtyN) qtyN.textContent = num(qty);
    }

    function sheetErr(key) {
      if (!sErr) return false;
      sErr.textContent = T(key);
      sErr.hidden = false;
      return false;
    }

    function openSheet(card) {
      lastFocus = document.activeElement;
      sel = null; qty = 1;
      if (sErr) sErr.hidden = true;

      /* Heading: the label, translated where the card supplies a key; the code
         itself is kept on the sheet so `commit()` can store both. */
      var cardCode = card.getAttribute('data-code') || '';
      var cardCodeKey = card.getAttribute('data-code-key') || '';
      sheet.setAttribute('data-code', cardCode);
      sheet.setAttribute('data-code-key', cardCodeKey);
      if (sCode) {
        if (cardCodeKey) sCode.setAttribute('data-i18n', cardCodeKey);
        else sCode.removeAttribute('data-i18n');
        sCode.textContent = dict(cardCodeKey, cardCode);
      }
      sheet.setAttribute('data-img', card.getAttribute('data-img') || '');

      /* Gallery. The strip is only shown when there is genuinely more than one
         shot — five of these colourways were photographed once, and a strip of
         a single thumbnail reads as broken rather than as a choice. */
      var imgs = (card.getAttribute('data-images') || '')
        .split('|')
        .map(function (u) { return u.trim(); })
        .filter(Boolean);
      if (!imgs.length) imgs = [card.getAttribute('data-img')].filter(Boolean);

      if (gMain && imgs.length) gMain.setAttribute('src', imgs[0]);
      if (gMain) gMain.setAttribute('alt', card.getAttribute('data-code') || '');

      if (gStrip) {
        gStrip.innerHTML = '';
        if (imgs.length > 1) {
          for (var g = 0; g < imgs.length; g++) {
            var tb = document.createElement('button');
            tb.type = 'button';
            tb.className = 'st-gal__t';
            tb.setAttribute('aria-pressed', g === 0 ? 'true' : 'false');
            tb.setAttribute('data-gsrc', imgs[g]);
            tb.setAttribute('aria-label', 'View image ' + (g + 1));
            var im = document.createElement('img');
            im.src = imgs[g];
            im.alt = '';
            im.loading = 'lazy';
            tb.appendChild(im);
            gStrip.appendChild(tb);
          }
          gStrip.hidden = false;
        } else {
          gStrip.hidden = true;
        }
      }

      sBody.innerHTML = '';
      /* The panel body is the scroller and it is NOT reset by replacing the
         chips, so without this a sheet reopened after a scroll starts wherever
         the last one was left — usually mid-photograph. */
      var scroller = sheet.querySelector('.st-sheet__body');
      if (scroller) scroller.scrollTop = 0;
      var chips = card.querySelectorAll('[data-variant]');
      for (var i = 0; i < chips.length; i++) {
        var c = chips[i];
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'st-sizes__b';
        b.textContent = c.getAttribute('data-size');
        b.setAttribute('aria-pressed', 'false');
        if (c.getAttribute('data-out') === 'true') b.disabled = true;
        b.setAttribute('data-v', c.getAttribute('data-variant'));
        b.setAttribute('data-p', c.getAttribute('data-price'));
        b.setAttribute('data-s', c.getAttribute('data-size'));
        sBody.appendChild(b);
      }

      sheetTotal();
      sheet.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
      /* the hero cycle listens for this and stands down */
      try { root.dispatchEvent(new CustomEvent('st:sheet-open')); } catch (e) {}
      var first = sBody.querySelector('.st-sizes__b:not(:disabled)');
      if (first) window.setTimeout(function () { first.focus(); revealSizes(); }, 220);
    }

    /* ----------------------------------------------------------------------
       Open the sheet ON the size chips.

       The sheet's footer is pinned to the bottom of the panel and the gallery
       above the chips is sized from the panel's WIDTH, so on a short or narrow
       phone the chips render inside the scrollport but underneath that footer.
       Measured 2026-09-17 with the Oxford colourways: on a 320x658 Galaxy the
       footer is 216px tall and starts at y=426 while the first chip sits at
       466, and `document.elementFromPoint` over that chip returns the footer.
       Focusing the chip does not help — the browser only scrolls for an element
       outside the scrollport, and this one is merely covered.

       So the overlap is measured and scrolled away, and nothing else: a phone
       with room to spare does not move at all, and one without keeps as much of
       the photograph as it can while still showing every chip.

       Opt-in via data-reveal-sizes, so a page that has not been checked for it
       (the stripe page) keeps the behaviour it shipped with.
       -------------------------------------------------------------------- */
    function revealSizes() {
      if (!CFG.revealSizes) return;

      /* `sBody` is the chip container, not the scroller — the element that
         scrolls is .st-sheet__body around it. */
      var scroller = sheet.querySelector('.st-sheet__body');
      var foot = sheet.querySelector('.st-sheet__foot');
      if (!scroller || !foot || !sBody) return;

      var overlap = sBody.getBoundingClientRect().bottom - foot.getBoundingClientRect().top;
      if (overlap > 0) scroller.scrollTop += overlap + 12;
    }

    function closeSheet() {
      sheet.setAttribute('data-open', 'false');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function commit() {
      if (!sel) return sheetErr('sheet.errSize');
      /* The label as displayed, plus the KEY it came from. Without the key a
         line added in English keeps reading English after the buyer switches to
         Bangla, because renderBag() prints a stored string. */
      var code = sheet.getAttribute('data-code') || (sCode ? sCode.textContent : '');
      var codeKey = sheet.getAttribute('data-code-key') || '';
      addLine({
        variant: sel.variant,
        size: sel.size,
        price: sel.price,
        qty: qty,
        code: code,
        codeKey: codeKey,
        img: sheet.getAttribute('data-img') || ''
      });

      /* Meta AddToCart. This is the only place a line enters the bag —
         addLine() has exactly one caller and commit() has two, both of them
         the same deliberate tap ("add to bag" / "buy now") — so the event
         fires once per add and cannot be double counted.

         Shopify's web pixel never sees this: the bag is localStorage until the
         /cart/<v>:<q> hand-off, so no cart AJAX call happens and
         product_added_to_cart never fires. Without this event a
         purchase-optimised campaign has nothing between PageView and checkout.

         value is in major units; sel.price is minor, like everything Liquid
         prints on this page. */
      if (window.stTrack) {
        window.stTrack('AddToCart', {
          content_type: 'product',
          content_ids: [String(sel.variant)],
          contents: [{ id: String(sel.variant), quantity: qty }],
          content_name: code || CFG.contentName,
          value: (sel.price * qty) / 100,
          currency: 'BDT'
        });
      }

      renderBag();
      return true;
    }

    /* The hero photograph is a buy action where the page opts in with
       data-hero-buy.

       On a 360px phone the first screen carries the headline, the price, the
       buttons and the colour rail but NO product card, so nothing above the
       fold could be bought. The rail chooses the colourway; tapping the
       photograph opens that colourway's sheet.

       The shown colourway is identified by the label in the hero badge, which
       the rail keeps in step, and matched to its card so the sheet is built
       from the same live variants the grid renders. If no card matches — a
       colourway that sold out between renders — nothing happens rather than
       opening an empty sheet. */
    function heroCard() {
      var tag = root.querySelector('[data-hero-code]');
      /* The ATTRIBUTE, not the text. The text is a label and may be translated;
         the attribute is the code the cards are keyed by. Falls back to the
         text for a page that sets no attribute — the stripe page's badge is
         rendered by Liquid and never touched again. */
      var code = tag ? ((tag.getAttribute('data-code') || tag.textContent || '')).trim() : '';
      if (!code) return null;
      var cards = root.querySelectorAll('[data-card]');
      for (var i = 0; i < cards.length; i++) {
        if ((cards[i].getAttribute('data-code') || '').trim() === code) return cards[i];
      }
      return null;
    }

    /* Cards are real links; intercept only the plain click, so modified and
       middle clicks still open the product page. */
    root.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
      var card = e.target.closest ? e.target.closest('[data-card]') : null;
      if (card) { e.preventDefault(); openSheet(card); return; }

      var heroBuy = e.target.closest ? e.target.closest('[data-hero-buy]') : null;
      if (heroBuy) {
        var hc = heroCard();
        if (hc) { e.preventDefault(); openSheet(hc); }
        return;
      }

      if (e.target.closest('[data-bag-open]')) { openBag(); return; }
      var dock = e.target.closest('[data-open-bag]');
      if (dock) { e.preventDefault(); openBag(); }
    });

    sheet.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-sheet-close]')) { closeSheet(); return; }

      var sz = t.closest('.st-sizes__b');
      if (sz && !sz.disabled) {
        var all = sBody.querySelectorAll('.st-sizes__b');
        for (var i = 0; i < all.length; i++) all[i].setAttribute('aria-pressed', 'false');
        sz.setAttribute('aria-pressed', 'true');
        sel = { variant: sz.getAttribute('data-v'), size: sz.getAttribute('data-s'), price: Number(sz.getAttribute('data-p')) || 0 };
        if (sErr) sErr.hidden = true;
        sheetTotal();
        return;
      }

      var gt = t.closest('[data-gsrc]');
      if (gt) {
        if (gMain) gMain.setAttribute('src', gt.getAttribute('data-gsrc'));
        var ts = gStrip.querySelectorAll('[data-gsrc]');
        for (var i2 = 0; i2 < ts.length; i2++) ts[i2].setAttribute('aria-pressed', ts[i2] === gt ? 'true' : 'false');
        return;
      }

      var q = t.closest('[data-qty]');
      if (q) { qty = Math.max(1, Math.min(MAX_QTY, qty + Number(q.getAttribute('data-qty')))); sheetTotal(); return; }

      if (t.closest('[data-sheet-add]')) {
        if (commit()) { closeSheet(); toast(T('toast.added')); }
        return;
      }
      if (t.closest('[data-sheet-buy]')) {
        if (commit()) { closeSheet(); openBag(); }
      }
    });

    /* ---- bag interactions ---- */

    bag.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-bag-close]')) { closeBag(); return; }
      if (t.closest('[data-bag-browse]')) { closeBag(); scrollToColourways(); return; }

      var li = t.closest('[data-line]');
      if (li) {
        var vid = li.getAttribute('data-line');
        var idx = -1;
        for (var i = 0; i < cart.length; i++) if (cart[i].variant === vid) idx = i;
        if (idx < 0) return;

        if (t.closest('[data-rm]')) {
          cart.splice(idx, 1);
          persist(); renderBag();
          toast(T('toast.removed'));
          return;
        }
        var lq = t.closest('[data-lq]');
        if (lq) {
          var next = cart[idx].qty + Number(lq.getAttribute('data-lq'));
          if (next < 1) cart.splice(idx, 1);
          else cart[idx].qty = Math.min(MAX_QTY, next);
          persist(); renderBag();
          return;
        }
      }

      var ar = t.closest('[data-area]');
      if (ar) {
        area = ar.getAttribute('data-area');
        var segs = bag.querySelectorAll('[data-area]');
        for (var k = 0; k < segs.length; k++) segs[k].setAttribute('aria-pressed', segs[k] === ar ? 'true' : 'false');
        renderBag();
        return;
      }

      if (t.closest('[data-bag-go]')) checkout();
    });

    function scrollToColourways() {
      var target = document.getElementById('colourways');
      if (target) target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
    }

    var heroStack = root.querySelector('[data-hero-buy]');
    if (heroStack) {
      heroStack.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var hc = heroCard();
        if (hc) { e.preventDefault(); openSheet(hc); }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (bag.getAttribute('data-open') === 'true') { closeBag(); return; }
      if (sheet.getAttribute('data-open') === 'true') closeSheet();
    });

    /* ---- checkout ---- */

    function val(name) {
      var f = bag.querySelector('[data-f="' + name + '"]');
      return f ? f.value.trim() : '';
    }

    function mark(name, bad) {
      var f = bag.querySelector('[data-f="' + name + '"]');
      if (f) {
        f.setAttribute('aria-invalid', bad ? 'true' : 'false');
        if (bad) f.focus();
      }
    }

    function bagErr(key) {
      if (!elBagErr) return false;
      elBagErr.textContent = T(key);
      elBagErr.hidden = false;
      return false;
    }

    function checkout() {
      if (!cart.length) return;
      if (elBagErr) elBagErr.hidden = true;

      /* Step one: reveal the details. Asking for an address before anyone has
         committed to checking out is where a landing page loses people. */
      if (elForm && elForm.hidden) {
        elForm.hidden = false;
        elGo.textContent = T('bag.go2');
        var f1 = elForm.querySelector('[data-f]');
        if (f1) {
          elForm.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest' });
          window.setTimeout(function () { f1.focus(); }, reduced ? 0 : 320);
        }
        return;
      }

      var name = val('name');
      if (name.length < 2) { mark('name', true); return bagErr('sheet.errName'); }
      mark('name', false);

      var phone = val('phone').replace(/[\s-]/g, '');
      if (!BD_PHONE.test(phone)) { mark('phone', true); return bagErr('sheet.errPhone'); }
      mark('phone', false);

      var addr = val('address');
      if (addr.length < 8) { mark('address', true); return bagErr('sheet.errAddr'); }
      mark('address', false);

      var city = val('city');
      if (city.length < 2) { mark('city', true); return bagErr('sheet.errCity'); }
      mark('city', false);

      /* Email is optional, and it is the ONLY thing that can prefill Shopify's
         Contact field — the shipping phone we pass does not. But it has to be
         an email or absent: measured 2026-09-17, a phone number in
         checkout[email] does not degrade, it replaces the whole checkout with
         Shopify's "Cart Error: Email is invalid" page. So anything that is not
         an address is refused HERE, where the buyer still has their form in
         front of them, rather than on an error page after the hand-off. */
      var email = val('email');
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        mark('email', true);
        return bagErr('sheet.errEmail');
      }
      mark('email', false);

      elGo.disabled = true;

      var parts = [];
      for (var i = 0; i < cart.length; i++) parts.push(cart[i].variant + ':' + cart[i].qty);

      var bits = name.split(/\s+/);
      var q = [];
      var add = function (k, v) { if (v) q.push(encodeURIComponent(k) + '=' + encodeURIComponent(v)); };
      var sp = 'checkout[shipping_address]';

      /* A lone name goes in LAST name, not first: orderCreate silently discards
         a MailingAddressInput whose lastName is empty, taking the phone and the
         whole address down with it. */
      add(sp + '[first_name]', bits.length > 1 ? bits[0] : '');
      add(sp + '[last_name]', bits.length > 1 ? bits.slice(1).join(' ') : name);
      add(sp + '[address1]', addr);
      add(sp + '[city]', city);
      add(sp + '[country]', 'Bangladesh');
      add(sp + '[phone]', phone);
      if (email) add('checkout[email]', email);
      add('attributes[Delivery area]', area === 'outside' ? 'Outside Dhaka' : 'Inside Dhaka');
      add('attributes[Source]', CFG.source);

      /* The bag has done its job once the buyer is on checkout, so it is
         cleared — but a copy is kept for half an hour, and restored only if the
         buyer actually comes BACK here (see PENDING_KEY above). */
      try {
        localStorage.setItem(PENDING_KEY, JSON.stringify({ at: Date.now(), lines: cart }));
        localStorage.removeItem(CART_KEY);
      } catch (e) {}

      window.location.href = '/cart/' + parts.join(',') + (q.length ? '?' + q.join('&') : '');
    }

    /* Money and every numeral have to re-render when the language flips. */
    var langBtns = root.querySelectorAll('[data-lang-btn]');
    for (var lb = 0; lb < langBtns.length; lb++) {
      langBtns[lb].addEventListener('click', function () {
        window.setTimeout(function () {
          renderBag();
          sheetTotal();
          /* applyLang() repaints every [data-i18n] node from the dictionary,
             which resets this button to "Checkout" even when step two is
             already open and the label should read "Place order". The action
             was still correct, but the label was telling the buyer the wrong
             thing about their own next tap. Restore it after the swap. */
          if (elForm && !elForm.hidden && elGo) elGo.textContent = T('bag.go2');
        }, 0);
      });
    }

    renderBag();
    sheetTotal();
  }
})();
